module.exports = __webpack_public_path__ + "src/assets/img/cmdProg7.f6360e45.svg";